import React, { useEffect, useState } from "react";
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import * as Styled from './styled';
import { Button } from "react-bootstrap";
import AddGroup from "./addGroup";
import { handleApiErrors } from '../../lib/api-errors';
import axios from "axios";
import GroupDetails from "./groupDetails";
import EditGroup from "./editGroup";

function Groups() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [testDetailsModal, setTestDetailsModal] = useState(false);
    const [editGroupModal, setEditGroupModal] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [itemValue, setItemValue] = useState([]);
    const [groupTitle, setGroupTitle] = useState({
        id:null,
        title:null
    });

    useEffect(() => { getGroups() }, []);

    const getGroups = async () => {
        const request = await axios(`${process.env.REACT_APP_WEB_API_DEV}api/v1/assessments/get-test-group`, {
            method: 'GET',
            headers: {
                authorization: localStorage.getItem("jwtToken"),
                'Content-Type': 'application/json'
            },
        })
        setGroupList(request?.data?.data);
    }

    const showModal = () => {
        setIsModalOpen(true);
    };


    const getDetails = (val) => {
        setItemValue(val);
        setTestDetailsModal(true);
    }
    const editDetails = (val,id) => {
        setGroupTitle({
            id:id,
            title:val
        });
        setEditGroupModal(true);
    }

    return (
        <div style={{ display: "flex" }}>
            <Sidemenu />

            <GroupDetails testDetailsModal={testDetailsModal} setTestDetailsModal={setTestDetailsModal} details={itemValue} />
            <EditGroup editGroupModal={editGroupModal} setEditGroupModal={setEditGroupModal} name={groupTitle.title} id={groupTitle.id} getGroups={getGroups} />

            <div style={{ height: "100vh", display: "flex", flexDirection: "column", flexGrow: "1", position: "relative" }}>
                <Header />
                <div style={{ paddingTop: "100px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "0 30px" }}>
                        <div style={{ fontSize: " 24px", fontWeight: "700" }}>All Groups</div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {isModalOpen && 
                            <AddGroup isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} getGroups={getGroups} />}

                            <button onClick={showModal} style={{
                                height: "40px",
                                backgroundColor: "#1B49EA",
                                color: "#ffffff",
                                borderRadius: "8px",
                                padding: "8px 17px",
                                fontSize: "14px",
                                fontWeight: "700"
                            }}

                            >
                                + Add New Group
                            </button>
                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "30px" }}>
                        <table style={{
                            background: "#FFFFFF",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
                            borderRadius: "8px",
                            margin: "0px 36px auto 36px"
                        }}>

                            <thead>
                                <tr style={{
                                    verticalAlign: "middle",
                                    backgroundColor: "#F7F8F9",
                                    borderRadius: "10px",
                                    padding: "30px",
                                    margin: "8px 30px 30px 30px"
                                }}>
                                    <th>Test Title</th>
                                    <th>No. of Easy</th>
                                    <th>No. of Medium</th>
                                    <th>No. of Hard</th>
                                    <th>Edit Group</th>
                                    <th>View More</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    groupList && groupList.length > 0
                                        ?
                                        groupList.map((item) => {
                                            return (
                                                <tr >
                                                    <td>{item?.groupTitle}</td>
                                                    <td>{item.EASY}</td>
                                                    <td>{item.MEDIUM}</td>
                                                    <td>{item.HARD}</td>
                                                    <td>
                                                        {item?.groupTitle?.length > 0 && <button onClick={() => editDetails(item?.groupTitle,item?.name)} style={{

                                                            height: "40px",
                                                            backgroundColor: "#1B49EA",
                                                            color: "#ffffff",
                                                            borderRadius: "8px",
                                                            padding: "8px 17px",
                                                            fontSize: "14px",
                                                            fontWeight: "700"
                                                        }}
                                                        >
                                                            Edit
                                                        </button>}
                                                    </td>
                                                    <td>
                                                        {item?.value?.length > 0 && <button onClick={() => getDetails(item?.value)} style={{
                                                            height: "40px",
                                                            backgroundColor: "#1B49EA",
                                                            color: "#ffffff",
                                                            borderRadius: "8px",
                                                            padding: "8px 17px",
                                                            fontSize: "14px",
                                                            fontWeight: "700"
                                                        }}

                                                        >
                                                            Details
                                                        </button>}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        "No more data available"
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>


        </div >
        // <Footer />
    )
}
export default Groups;
